import { IdentityDto } from './../shared/identity.dto';
import { TimeSpecDto } from './time-spec.dto';
import { OperationSpecDto } from './operation-spec.dto';
import { CronExpressionDto } from './cron-expression.dto';

/***
 * Difhub version: 1.1.0 draft
 * https://difhub.com/view/organizations/Business%20Systems/systems/Settlement/applications/Billing/datasets/Delivery/versions/1
 */
export class DeliveryDto {
  identity = new IdentityDto();
  times: TimeSpecDto[] = [];
  expression = new CronExpressionDto();
  operations: OperationSpecDto[] = [];

  constructor(d?: DeliveryDto) {
    if (!d) {
      return;
    }
    if (d.identity) {
      this.identity = new IdentityDto(d.identity);
    }
    if (d.times) {
      this.times = d.times.map(t => new TimeSpecDto(t));
    }
    if (d.operations) {
      this.operations = d.operations.map(o => new OperationSpecDto(o));
    }
    if (d.expression) {
      this.expression = new CronExpressionDto(d.expression);
    }
  }
}
